import { Banner } from "@alpacahq/ui/old";

export const PaperWarningBanner = () => {
  return (
    <Banner
      variant="info"
      message="You are on Paper Trading, no real money is being used."
      className="mx-6 mr-8 mb-6 xs:ml-0"
    />
  );
};
